<div
  id="employee_visiting_card"
  class="modal custom-modal fade"
  role="dialog"
  style="display: none"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Request For Visiting Card</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeModal()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="visitCardForm" (ngSubmit)="submitVisitCard()">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Employee <span class="text-danger">*</span></label>
                <input
                  class="form-control"
                  type="text"
                  formControlName="username"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label
                  >Contact Number <span class="text-danger">*</span>
                  <a
                    ><button
                      class="btn btn-sm btn-warning"
                      (click)="gotoQuery()"
                      routerLink="/queries/create"
                    >
                      <i class="fa fa-location-arrow" aria-hidden="true"></i>
                      Raise a Query
                    </button></a
                  >
                </label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="number"
                  placeholder="Contact Number"
                  readonly
                />
                <div
                  *ngIf="submitted && getVstngErr.number.errors"
                  class="form-error"
                >
                  <div *ngIf="getVstngErr.number.errors.required">
                    Contact Number is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label
                  >No of Visiting Card <span class="text-danger">*</span></label
                >
                <select class="form-control" formControlName="no_of_vc">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <div
                  *ngIf="submitted && getVstngErr.no_of_vc.errors"
                  class="form-error"
                >
                  <div *ngIf="getVstngErr.no_of_vc.errors.required">
                    No of Card is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label
                  >Email ID <span class="text-danger"></span>
                  <a
                    ><button
                      class="btn btn-sm btn-warning"
                      (click)="gotoQuery()"
                      routerLink="/queries/create"
                    >
                      <i class="fa fa-location-arrow" aria-hidden="true"></i>
                      Raise a Query
                    </button></a
                  ></label
                >
                <input
                  type="text"
                  class="form-control"
                  formControlName="email_id"
                  placeholder="Email ID"
                  readonly
                />
                <div
                  *ngIf="submitted && getVstngErr.email_id.errors"
                  class="form-error"
                >
                  <div *ngIf="getVstngErr.email_id.errors.required">
                    Email ID is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Department <span class="text-danger"></span></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="depart"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Segment <span class="text-danger"></span></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="segment"
                  readonly
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label
                  >Base office / Site address <span class="text-danger"></span
                ></label>
                <select
                  class="form-control"
                  formControlName="add_type"
                  (change)="changeAddType()"
                >
                  <option value="">Select</option>
                  <option value="1">Base Office</option>
                  <option value="2">Site Address</option>
                  <option value="3">Mention Your Address</option>
                </select>
                <div
                  *ngIf="submitted && getVstngErr.add_type.errors"
                  class="form-error"
                >
                  <div *ngIf="getVstngErr.add_type.errors.required">
                    Please choose an option !
                  </div>
                </div>
                <textarea
                  type="text"
                  class="form-control"
                  formControlName="address"
                  placeholder="Enter Address.."
                  rows="4"
                  cols="50"
                  *ngIf="add_type == 3"
                ></textarea>
                <select
                  class="form-control"
                  formControlName="address"
                  (change)="changeAdd($event)"
                  *ngIf="add_type == 1"
                >
                  <option value="">Select</option>
                  <option
                    *ngFor="let data of addressList"
                    value="{{ data.value }}"
                  >
                    {{ data.label }}
                  </option>
                </select>

                <span *ngIf="add_type == 2">
                  <input
                    type="text"
                    list="all_pccode"
                    class="form-control"
                    placeholder="PC Code"
                    (change)="changePcCode($event)"
                  />
                  <datalist id="all_pccode">
                    <option
                      [value]="plant.value"
                      *ngFor="let plant of costCenteres"
                    >
                      {{ plant.label }}
                    </option>
                  </datalist>
                </span>
                <span *ngIf="(address && add_type == 1) || add_type == 2">{{
                  address
                }}</span>
                <div
                  *ngIf="submitted && getVstngErr.address.errors"
                  class="form-error"
                >
                  <div *ngIf="getVstngErr.address.errors.required">
                    Address is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label
                  >Land Line Number with STD Code (*Optional)<span
                    class="text-danger"
                  ></span
                ></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="std_code"
                  placeholder="Land Line Number with STD Code"
                />
              </div>
            </div>
            <!-- <div class="col-md-4">
              <div class="form-group">
                <label>Fax Number <span class="text-danger"></span></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="fax_no"
                  placeholder="Fax Number"
                />
              </div>
            </div> -->
          </div>

          <div class="text-center">
            <button class="btn btn-primary btn-sm">Submit</button>
          </div>
        </form>
        <div class="row m-t-30">
          <div class="col-md-12">
            <div class="text-center m-b-10">
              <b>Visiting Card History</b>
            </div>

            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>Sr No.</th>
                    <th>Employee</th>
                    <th>Mobile</th>
                    <th>VisitCard</th>
                    <th>Region</th>
                    <th>Cost Center</th>
                    <th>Requested Date</th>
                    <th>RM Name</th>
                    <th>Approve Date</th>
                    <th>Resolved Date</th>
                    <th>Resolved By</th>
                    <th>Spoc Remark</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of vstngData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.EmpName }}</td>
                    <td>{{ item.mobile }}</td>
                    <td>{{ item.no_of_vstng }}</td>
                    <td>{{ item.rgn_name }}</td>
                    <td>{{ item.cc_ext_id }} - {{ item.cc_desc }}</td>
                    <td>{{ item.req_date }}</td>
                    <td>{{ item.RmName }}</td>
                    <td>{{ item.appr_date }}</td>
                    <td>{{ item.complete_date }}</td>
                    <td>{{ item.CompltByEmpName }}</td>
                    <td>{{ item.spoc_remark }}</td>
                    <td>{{ item.req_status_desc }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
